import { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UsecatEquipDD = (url, search, categoryId) => {
  const [data, setData] = useState([]);

  const getData = async () => {
    try {
      const res = await axiosInstance.get(url, {
        params: {
          search: search || "",         // optional search
          categoryId: categoryId || ""  // optional categoryId
        }
      });

      console.log(res.data, 'Product Dropdown Response');

      const tempData = res.data.map((item) => ({
        value: item.id,
        name: item.name,
        refNumber: item.refNumber || "",
        unit: item.unit || "",
        label: `${item.name || "Unnamed"}`
      }));

      setData(tempData);
    } catch (err) {
      console.error(err, 'Product dropdown error');
      setData([]);
    }
  };

  useEffect(() => {
    getData();
  }, [url, search, categoryId]); // ✅ categoryId dependency added

  return { data, setData };
};

export default UsecatEquipDD;
